import { InjectionToken } from '@angular/core';

/** When true, renders the web cabinet chrome header (logo, return-to-site). */
export const CABINET_CLIENT_SHELL_SHOW_WEB_HEADER = new InjectionToken<boolean>(
  'CABINET_CLIENT_SHELL_SHOW_WEB_HEADER',
  {
    factory: (): boolean => false,
  },
);
